// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"7":"1bfa27fd","96":"1bfa27fd","286":"240e51ac","423":"1bfa27fd","639":"1bfa27fd","720":"3fb52175"}[chunkId] + ".chunk.css";
};